/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/get_asset_metadata" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdGetAssetMetadata } from "./constants";
import type { EngagementAppGroupIdGetAssetMetadataResult } from "./types";
import { isEngagementAppGroupIdGetAssetMetadataResult } from "./validators";

export const getEngagementAppGroupIdGetAssetMetadata = reactQueryFetcherAdapter(
  engagementAppGroupIdGetAssetMetadata,
  (
    signal: AbortSignal,
    appGroupId: string,
    imageUrl: string
  ): Promise<EngagementAppGroupIdGetAssetMetadataResult> => {
    return fetch(`/engagement/${appGroupId}/get_asset_metadata`, "GET", { image_url: imageUrl }, { signal });
  },
  isEngagementAppGroupIdGetAssetMetadataResult
);
